import $api from "../../axios"
import {AppDispatch} from "../index"
import {clientSlice} from "../slices/clientSlice"
import {IClient, IClientGetParams, IClientList, IFetchClientsParams} from "../../models/client"
import {IOrderListPayload} from "../../models/order"

export const fetchClients = (params: IFetchClientsParams) => async (dispatch: AppDispatch) => {
  try {
    dispatch(clientSlice.actions.fetching())
    const response = await $api.get<IClientList>('client/client/index', {
      params
    })
    dispatch(clientSlice.actions.fetchSuccess(response.data))
  } catch (e: any) {
    dispatch(clientSlice.actions.fetchError(e))
  }
}

export const addClient = (data: object) => async (dispatch: AppDispatch) => {
  try {
    dispatch(clientSlice.actions.adding())
    const response = await $api.post<IClient>("client/client/add", data)
    dispatch(clientSlice.actions.addSuccess(response.data))
    return response.data.id
  } catch (e: any) {
    if (e.response.status === 422) {
      dispatch(clientSlice.actions.saveError(e.response.data))
    }
  }
}

export const updateClient = (data: object) => async(dispatch: AppDispatch) => {
  try {
    dispatch(clientSlice.actions.updating())
    const response = await $api.put<IClient>("client/client/edit", data)
    dispatch(clientSlice.actions.updateSuccess(response.data))
    return true
  } catch (e: any) {
    if (e.response.status === 422) {
      dispatch(clientSlice.actions.saveError(e.response.data))
    }
  }
}

export const deleteClient = (client_uuid: string) => async (dispatch: AppDispatch) => {
  try {
    await $api.delete("client/client/delete", {
      params: {
        client_uuid
      }
    })
    return true
  } catch (e:any) {
    dispatch(clientSlice.actions.fetchError(e.message))
  }
}

export const getClient = (params: IClientGetParams) => async (dispatch: AppDispatch) => {
  try {
    dispatch(clientSlice.actions.fetchingClient())
    const response = await $api.get<IClient>("client/client/get", {params})
    dispatch(clientSlice.actions.fetchClientSuccess(response.data))
  } catch (e: any) {
    dispatch(clientSlice.actions.fetchClientError(e.message))
  }
}

export const setCurrentPage = (pageNumber: number) => (dispatch: AppDispatch) => {
  dispatch(clientSlice.actions.setCurrentPage(pageNumber))
}

export const fetchOrderHistory = (client_uuid: string) => async (dispatch: AppDispatch) => {
  try {
    dispatch(clientSlice.actions.fetchingOrderHistory())
    const response = await $api.get<IOrderListPayload>("request/request/index", {
      params: {
        client_uuid,
        page: 1,
        pageSize: 0
      }
    })
    dispatch(clientSlice.actions.fetchOrderHistorySuccess(response.data))
  } catch (e: any) {
    dispatch(clientSlice.actions.fetchOrderHistoryError(e.message))
  }
}